import PrivateFromsApi from '@/api/formPrivate'
import uiHelper from '@/helpers/ui'

export default {
  namespaced: true,

  state: {
    archivedSubmissions: []
  },

  getters: {
    archivedSubmissions: state => state['archivedSubmissions']
  },

  mutations: {
    setArchivedSubmissions(state, data) {
      state.archivedSubmissions = data
    },

    addToArchivedSubmissions(state, submissions) {
      state.archivedSubmissions.push.apply(
        state.archivedSubmissions,
        submissions
      )
    }
  },

  actions: {
    async getArchivedSubmissions(
      { commit },
      { formId, page = 1, searchTerm = '' }
    ) {
      uiHelper.progressBarStatus(true)
      let response = null
      try {
        response = await PrivateFromsApi.getArchivedSubmissions(
          formId,
          page,
          searchTerm
        )
        if (response.data.payload.page === 1) {
          commit('setArchivedSubmissions', response.data.payload.submissions)
        } else {
          commit('addToArchivedSubmissions', response.data.payload.submissions)
        }
      } catch (error) {
        commit('setArchivedSubmissions', [])
        uiHelper.showSnackbarMessage('No Archived submissions found.', 'error')
      } finally {
        uiHelper.progressBarStatus(false)
      }
      return response
    }
  }
}
